import { combineReducers } from 'redux'
import misc from './misc'
import requests from './requests'

export default combineReducers({
  misc,
  requests,
})
